import React from 'react';
import checkbox from "../../images/check_box-24px 1.png";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faChevronRight } from '@fortawesome/free-solid-svg-icons'


class Welcome extends React.Component  {
    constructor(props) {
        super(props);
        this.handleLanguageChange   = this.handleLanguageChange.bind(this);
    }
        
    handleLanguageChange = (e) =>{
        const selected = e.target.value;
        const url = selected === "au" ? "/" : "/"+selected;
        window.location.href = url;
    }

    render() {
        const {handleChange, showModal, showError, handleNext, handleClick, hotelCode, hotelName, hotelSearchResults, hotelSearch} = this.props;
        return (
            <div className="hotelSales-hotelDetails container">
                <div className="hotelSales-welcomeMsg mt-5">
                    <div>
                        <h4>Welcome to Accor Plus Loyalty Ambassador</h4>
                        <p>Before we get started, there are 3 short questions to ensure we have all the needed detail to successfully complete the transaction.</p>
                        <p>To assist the customer with the appropriate product selection, please see below our key membership benefits.</p>
                    </div>
                    <div>
                        <h4>Supplied details</h4>
                        <p>Employee type: Loyalty Ambassador</p>
                    </div>
                </div>
        
                <h4>Hotel details <sup>*</sup></h4>
                <p>Please provide your hotel details for sales tracking</p>

                <div className="hotel-code-container row">
                    <div className="form-group col-12 col-md-6">
                        <label className="ridCode">Hotel Booking code / RID code <sup>*</sup></label>
                        <input type="text" placeholder="Enter RID Code" className={`form-control ${showError && !hotelCode ? ' border border-danger' : ''}`} required value={hotelCode && hotelCode.toUpperCase()} onChange={handleChange}/>
                        {showError && !hotelCode && (
                            <div className="error">Enter the RID Code here. <a onClick={showModal} href="#">Click here to perform a search.</a>.</div>
                        )}
                        <button className="btn btn-secondary mt-4" onClick={handleClick}>CHECK <FontAwesomeIcon icon={faCheck} /></button>
                    </div> 

                    {hotelSearch && !hotelSearchResults && (
                        <div className="hotel-results-container col-12 col-md-6">
                            <h5>Result</h5>
                            <div className="mt-3">
                                No results. <a onClick= {showModal} href="#">Click here to perform a search.</a>
                            </div>
                            </div>
                    )}
                    
                    {hotelSearch && hotelSearchResults && hotelName && hotelCode && (
                        <div className="hotel-results-container col-12 col-md-6">
                            <h5>Result</h5>
                            <div className="mt-3">
                                <img src={checkbox} width="25"/> {hotelName} -RID {hotelCode}
                            </div>
                        </div>
                    )}
                </div>

                <div className="mt-2">
                    <p>Don't know your hotel code? <a onClick= {showModal} href="#">Click here to perform a search</a></p>
                </div>

                <div className="d-flex justify-content-between">
                    <p className="disclaimer">*mandatory question</p>
                    <button 
                        className="btn btn-primary"
                        onClick={handleNext}>Next <FontAwesomeIcon icon={faChevronRight} /></button>
                </div>
            </div>
        );
    }
}

export default (Welcome);